const escapeHtml = (text) => text === null || text === undefined ? '' : String(text)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#039;')

export const tableHtml = (title, html, options = {}) => {
  // Only show title for non-certificate prints (tables, brackets, etc.)
  // For certificates, we want NO extra content - just the certificates themselves
  const showTitle = options.showTitle !== false
  // Escape the title (user-controlled club/tournament/category name); `html`
  // is already-built markup from the caller and is intentionally raw.
  const titleHTML = showTitle && title ? `<h1>${escapeHtml(title)}</h1>` : ''

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${title || process.env.VUE_APP_TITLE}</title>
      <style>
        * {
          box-sizing: border-box;
        }

        body {
          font-family: "Open Sans", sans-serif;
          font-size: 12px;
          margin: 0;
          padding: 15mm 15mm 0 15mm;
        }
        h1 {
          text-align: center;
          margin: 0 0 30px 0;
          box-sizing: border-box;
          padding: 0;
          max-width: 100%;
          margin-left: auto;
          margin-right: auto;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
        h2 {
          margin: 0 0 15px 0;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
        h3 {
          margin: 20px 0 10px 0;
        }
        h4 {
          margin: 10px 0 15px 0;
        }
        table {
          width: 100%;
          border: none;
          border-collapse: collapse;
          border-top: 1px solid #d1d1d1;
        }
        table thead tr {
          border-bottom: 1px solid #d1d1d1;
        }
        table thead tr th {
          text-align: left;
          padding: 7px 12px;
        }
        table tbody tr {
          border-bottom: 1px solid #d1d1d1;

        }
        table tbody tr td {
          text-align: left;
          padding: 7px 12px;
        }

        .data-list-item {
          line-height: 1.5;
        }

        .data-list-item .label {
          fonts-size: 10px;
          font-weight: 500;
          color: #000;
        }

        .data-list-item .text {
          fonts-size: 12px;
          color: #444;
        }

        /* Registration fee print – horizontal margins so content does not touch edges */
        .registration-fee-print {
          padding-left: 0;
          padding-right: 0;
          box-sizing: border-box;
        }

        /* Registration fee totals section – extra right padding so totals don’t get cut off when printing */
        .fee-summary-row {
          text-align: right;
          margin-top: 10px;
          padding-right: 0;
          box-sizing: border-box;
        }

        .discipline-section {
          page-break-after: always;
          page-break-inside: avoid;
          margin-bottom: 40px;
        }

        .discipline-section:last-child {
          page-break-after: auto;
        }

        .discipline-section table {
          page-break-inside: auto;
        }

        .discipline-section table thead {
          display: table-header-group;
        }

        .discipline-section table tbody {
          display: table-row-group;
        }

        .discipline-section table tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        .club-logo-cell {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }

        .club-logo {
          width: 32px;
          height: 32px;
          object-fit: contain;
          vertical-align: middle;
        }

        .placement-header {
          white-space: nowrap;
          min-width: 72px;
        }

        .placement-cell {
          width: 44px;
          text-align: center;
          vertical-align: middle;
        }

        .placement-box {
          display: inline-block;
          width: 28px;
          height: 28px;
          border: 1px solid #333;
          background: #fff;
        }

        /* Bracket competitor list table – ensure photo, club logo and placement print like on screen */
        /* Use same 10mm side margins as bracket print for consistent layout; top padding for print margin */
        .competitor-list-section {
          display: block;
          width: 100%;
          page-break-inside: avoid;
          box-sizing: border-box;
          padding: 0 10mm;
        }
        .competitor-list-header { margin-bottom: 15px; padding-bottom: 10px; border-bottom: 2px solid #333; }
        .competitor-list-tournament { margin: 0 0 4px 0; font-size: 20px; font-weight: 700; color: #222; }
        .competitor-list-title { margin: 0 0 8px 0; font-size: 18px; font-weight: bold; color: #333; }
        .competitor-list-subtitle { margin: 0 0 8px 0; font-size: 14px; color: #555; }
        .competitor-count { font-size: 14px; color: #666; font-weight: 500; }
        .competitor-table { width: 100%; border-collapse: collapse; font-size: 12px; border-top: 1px solid #333; border-bottom: 1px solid #333; }
        .competitor-table thead { background-color: #f5f7fa; }
        .competitor-table th, .competitor-table td { border: none; border-bottom: 1px solid #333; padding: 8px; vertical-align: middle; }
        .competitor-table th { font-weight: 600; color: #333; background-color: #f5f7fa; }
        .competitor-table td { background-color: #fff; color: #333; }
        .competitor-table .image-cell { width: 80px; min-width: 80px; text-align: center; padding: 5px; vertical-align: middle; }
        .competitor-table .avatar-container {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          position: relative;
        }
        .competitor-table .avatar-placeholder {
          display: block;
          width: 60px;
          height: 60px;
          min-width: 60px;
          min-height: 60px;
          border-radius: 4px;
          background-color: #f0f0f0;
          border: 1px solid #dcdfe6;
          position: absolute;
          top: 0;
          left: 0;
        }
        .competitor-table .competitor-avatar {
          display: block;
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 4px;
          position: relative;
          z-index: 1;
        }
        .competitor-table .club-cell { vertical-align: middle; }
        .competitor-table .club-logo-wrapper { display: inline-block; vertical-align: middle; margin-right: 6px; }
        .competitor-table .club-logo-placeholder {
          display: inline-block;
          width: 28px;
          height: 28px;
          min-width: 28px;
          min-height: 28px;
          border-radius: 2px;
          vertical-align: middle;
          background-color: #e8e8e8;
          border: 1px solid #d0d0d0;
        }
        .competitor-table .club-logo { width: 28px; height: 28px; object-fit: contain; vertical-align: middle; }
        .competitor-table .club-text { display: inline; vertical-align: middle; }
        .competitor-table .placement-cell { text-align: center; }
        .competitor-table .placement-checkbox {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 1px solid #333;
          background-color: #fff;
          vertical-align: middle;
        }

        @media print {
          /* Remove all browser-generated headers and footers */
          @page {
            size: A4;
            margin: 0;
          }

          * {
            margin: 0;
            padding: 0;
          }

          body {
            margin: 0 !important;
            padding: 15mm 15mm 0 15mm !important;
          }

          .discipline-section {
            page-break-after: always;
            page-break-inside: avoid;
          }

          .discipline-section:last-child {
            page-break-after: auto;
          }

          /* Force competitor table photo, club logo and placement to print */
          .competitor-table .image-cell,
          .competitor-table .avatar-container,
          .competitor-table .avatar-placeholder,
          .competitor-table .competitor-avatar,
          .competitor-table .club-logo-wrapper,
          .competitor-table .club-logo-placeholder,
          .competitor-table .club-logo,
          .competitor-table .placement-cell,
          .competitor-table .placement-checkbox {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .competitor-table .avatar-placeholder {
            background-color: #f0f0f0 !important;
            border: 1px solid #dcdfe6 !important;
          }
          .competitor-table .club-logo-placeholder {
            background-color: #e8e8e8 !important;
            border: 1px solid #d0d0d0 !important;
          }
          .competitor-table .placement-checkbox {
            border: 1px solid #333 !important;
            background-color: #fff !important;
          }

          /* Same 10mm side margins as bracket for competitors table; top spacing comes
             from the body padding (first page) or the page-break wrapper (later pages). */
          .competitor-list-section {
            padding: 0 10mm !important;
            box-sizing: border-box !important;
          }

          .registration-fee-print {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }

          .fee-summary-row {
            padding-right: 0 !important;
          }
        }
      </style>
    </head>
    <body>
      ${titleHTML}
      ${html}
    </body>
    </html>
  `
}

const openPrint = (title, el, options = {}) => {
  if (!el) return
  const newWin = window.open('')

  // Print exactly what the caller passed in. Callers that need a competitors
  // table (bracket print) append it themselves, honouring the print options
  // chosen in "Opcije štampe" – pulling one out of window.opener here would
  // inject an unfiltered table (with competitor photos) that ignores them.
  const htmlContent = el.innerHTML

  newWin.document.write(tableHtml(title, htmlContent, options))
  newWin.print()
  newWin.close()
}

export default openPrint
